/**
 * Support (#652, OrderOS/CommandOS #1825): the suite's one Ticket Center, not a Brunel copy.
 *
 * Darius mounts the shared CommandOS reporter in-app because OrderOS signs in to the suite's
 * Supabase project; every ticket write there runs as the reporter's own CommandOS session. Brunel
 * signs in to its own project, so a Brunel token cannot file one. Owner ruling 2026-09-25: Brunel's
 * Support opens CommandOS instead, handing over only what the shared reporter would capture itself
 * - source app 'brunel', this build's version, the Brunel surface and the environment. CommandOS's
 * signed-in session then files it through the same reporter, intake and queue, labelled Brunel.
 *
 * Nothing else leaves Brunel: no token, no terminal output, no prompt, no page content.
 */

export const COMMANDOS_SUPPORT_ORIGIN = 'https://command.odarius.com/';
export const BRUNEL_SUPPORT_APP_KEY = 'brunel';

export function brunelSupportVersion(version: string, buildId: string): string {
  const base = version.trim() || 'dev';
  const build = buildId.trim();
  return build === '' || build === 'dev' ? base : `${base}+${build}`;
}

export function brunelSupportUrl(input: {
  readonly version: string;
  readonly buildId: string;
  /** The Brunel surface the owner is on, e.g. the section id. */
  readonly surface: string;
  readonly production: boolean;
}): string {
  const url = new URL(COMMANDOS_SUPPORT_ORIGIN);
  url.searchParams.set('support', BRUNEL_SUPPORT_APP_KEY);
  url.searchParams.set('version', brunelSupportVersion(input.version, input.buildId));
  url.searchParams.set('route', `/${input.surface.replace(/[^a-z0-9-]/gi, '')}`);
  url.searchParams.set('env', input.production ? 'production' : 'development');
  return url.toString();
}
